import { Box } from "@chakra-ui/react"

export const Option = ({children}) => {
    return (
        <Box p="1">
            {children}
        </Box>
    )
}